import { render, staticRenderFns } from "./AdminCapacityPage.vue?vue&type=template&id=dc66410c&scoped=true&"
import script from "./AdminCapacityPage.vue?vue&type=script&lang=js&"
export * from "./AdminCapacityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc66410c",
  null
  
)

export default component.exports